import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tab", { active: _ctx.tab.active, disabled: _ctx.tab.disabled }])
  }, _toDisplayString(_ctx.$t(_ctx.tab.label)), 3))
}